import {Identifier} from "../common/Identifier";
import {Country} from "../common/Address";
import {Dateable} from "../common/TimePeriodable";
import {DateMap} from "./Calendar";

export interface HolidayId {
    holidayId: Identifier<number>
}


export interface Holiday extends HolidayId {
    name: string
    country: Country
    provinces: []
    isPublicHoliday: boolean
    year: number
    day: number
    month: number
    date: Dateable
}

export interface HolidayProp {
    holiday: Holiday
}

/**
 * key is date as string "{DAY}_{MONTH}_{YEAR}"
 *
 */
export type HolidayMap = DateMap< Holiday >

export type HolidayMapProp = {
    holidays: HolidayMap
}

/**
 * creates the map key from given date
 * adds +1 to month to get the correct value, since javascript date.getMonth returns 0-11
 */
export function dateMapKey(date: Date ): string {
    return `${ date.getDate()}_${( date.getMonth() + 1 )}_${ date.getFullYear() }`;
}